import { createAction, props } from '@ngrx/store';
import { CampaignCategory, CampaignEnums } from '../models/wizard.model';
import { HttpErrorResponse } from '@angular/common/http';

export const currentStep = createAction('[Wizard]: Current Step', props<{ currentStepIndex: number }>());

export const nextStep = createAction('[Wizard]: Next Step');

export const previousStep = createAction('[Wizard]: Previous Step');

export const goToStep = createAction('[Wizard]: Go To Step', props<{ index: number }>());

export const WizardCampaignSelectionTargetChanged = createAction(
  '[Wizard]: Campaign Selection Target Changed',
  props<{ campaignSelectionTarget: string }>(),
);

export const CampaignCategoriesInit = createAction('[Wizard]: Wizard Campaign Categories Init');

export const CampaignCategoriesSuccess = createAction(
  '[Wizard]: Wizard Campaign Categories Success',
  props<{ campaignCategories: CampaignCategory[] }>(),
);

export const CampaignCategoriesFailure = createAction(
  '[Wizard]: Wizard Campaign Categories Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const CampaignEnumsInit = createAction('[Wizard]: Wizard Campaign Enums Init');

export const CampaignEnumsSuccess = createAction(
  '[Wizard]: Wizard Campaign Enums Success',
  props<{ campaignEnums: CampaignEnums }>(),
);

export const CampaignEnumsFailure = createAction(
  '[Wizard]: Wizard Campaign Enums Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const CampaignCategoryChanged = createAction(
  '[Wizard]: Wizard Campaign Category Changed',
  props<{ campaignCategoryId: number }>(),
);

export const CampaignNameChanged = createAction(
  '[Wizard]: Wizard Campaign Name Changed',
  props<{ campaignName: string }>(),
);

export const SaveCampaignInit = createAction('[Wizard]: Wizard Save Campaign Init');

export const SaveCampaignSuccess = createAction('[Wizard]: Wizard Save Campaign Success', props<{ res: any }>());

export const SaveCampaignFailure = createAction(
  '[Wizard]: Wizard Save Campaign Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const UpdateCampaignInit = createAction('[Wizard]: Wizard Update Campaign Init');

export const UpdateCampaignSuccess = createAction('[Wizard]: Wizard Update Campaign Success', props<{ res: any }>());

export const UpdateCampaignFailure = createAction(
  '[Wizard]: Wizard Update Campaign Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenSaveCampaignModal = createAction('[Wizard]: Wizard Open Save Campaign Modal');

export const CloseSaveCampaignModal = createAction('[Wizard]: Wizard Close Save Campaign Modal');

export const ResetWizard = createAction('[Wizard] Reset Wizard State');
